
import Vue from 'vue';

import "../base/layout-bom";

// collect gfx3d specific components
import FragmentGfx3dForm from "../base/output/gfx3d/fragment-gfx3d-form.vue";
import FragmentGfx3dSubmit from "../base/output/gfx3d/fragment-gfx3d-submit.vue";
import FragmentGfx3dBoardModification from "../base/output/gfx3d/fragment-gfx3d-board-modification.vue";
const mixinComponents = {
    "mc/gfx3d/form": FragmentGfx3dForm,
    "mc/gfx3d/submit": FragmentGfx3dSubmit,
    "mc/gfx3d/board/modification": FragmentGfx3dBoardModification
};

// register components with mixin gfx3d specific components
import { registerComponents } from '../base/output/output-fragment-register';
registerComponents(mixinComponents);


import Gfx3dLayout from './gfx3d.vue';
import store from "./../base/store";

import Logger from "../../shared/logger";

const LOGGER = new Logger(__filename);

new Vue({ //NOSONAR 
    store,
    el: '#app',
    render: h => h(Gfx3dLayout),
    mounted() {
        const that = this;
        Vue.nextTick(() => {
            that.$store.dispatch("init");
        });
    }
});

LOGGER.log("==================================");
LOGGER.log("======== GFX3D LAYOUT ============");
LOGGER.log("==================================");


